import service from '../../../http/axios';

// 查询用户
export const findUser = service({
  url: '/yinghe-api/imageDataScienceInitiate/getUserByPhone',
});
